import {
  EquipmentCategory,
  EquipmentData,
  EquipmentType,
  StoppageKind,
  shifthandoverStoppagesList
} from '../../types'
import {
  Stoppage,
  StoppageDto,
  BaseEventDto,
  ShiftEventTaskDto,
  BaseEvent,
  Task,
  Information,
  ParameterChange,
  ParameterChangeDto,
  Idea,
  SystemChangeRequest,
  SystemChangeRequestDto,
  Quality,
  Spot,
  Environment,
  HealthAndSafety,
  StoppageType
} from '../types'

export const isStoppageEventType = (type: unknown): type is StoppageKind =>
  shifthandoverStoppagesList.includes(type as StoppageKind)

export const isStoppage = (event: BaseEvent): event is Stoppage =>
  isStoppageEventType(event.eventType)

export const isStoppageDto = (event: BaseEventDto): event is StoppageDto =>
  isStoppageEventType(event.eventType)

export const isPartialStoppage = (event: Partial<BaseEvent>): event is Partial<Stoppage> =>
  isStoppageEventType(event.eventType)

export function isTask(event: Partial<BaseEvent>): event is Task {
  return event.eventType === 'task'
}
export function isTaskDto(event: BaseEventDto): event is ShiftEventTaskDto {
  return event.eventType === 'task'
}

export function isInformation(event: BaseEvent): event is Information {
  return event.eventType === 'information'
}

export function isIdea(event: BaseEvent): event is Idea {
  return event.eventType === 'idea'
}

export function isQuality(event: BaseEvent): event is Quality {
  return event.eventType === 'quality'
}

export function isEnvironment(event: BaseEvent): event is Environment {
  return event.eventType === 'environment'
}

export function isHealthAndSafety(event: BaseEvent): event is HealthAndSafety {
  return event.eventType === 'healthAndSafety'
}

export function isParameterChange(event: Partial<BaseEvent>): event is ParameterChange {
  return event.eventType === 'parameterChange'
}

export function isParameterChangeDto(event: BaseEventDto): event is ParameterChangeDto {
  return event.eventType === 'parameterChange'
}

export function isSystemChangeRequest(event: Partial<BaseEvent>): event is SystemChangeRequest {
  return event.eventType === 'systemChangeRequest'
}

export function isSpot(event: Partial<BaseEvent>): event is Spot {
  return event.eventType === 'spot'
}

export function isSystemChangeRequestDto(
  event: Partial<BaseEventDto>
): event is SystemChangeRequestDto {
  return event.eventType === 'systemChangeRequest'
}

const STOPPAGE_TYPE_MAP: Record<EquipmentCategory, StoppageType> = {
  [EquipmentCategory.CEMENT]: 'cementMill',
  [EquipmentCategory.RAW]: 'rawMill',
  [EquipmentCategory.COAL]: 'coalMill',
  [EquipmentCategory.CLINKER]: 'kiln',
  [EquipmentCategory.CRUSHER]: 'crusher',
  [EquipmentCategory.UNKNOWN]: 'other',
  [EquipmentCategory.ENVIRONMENTAL]: 'other',
  [EquipmentCategory.FUEL]: 'other',
  [EquipmentCategory.PACKING]: 'other'
}

/**
 * The expectations should map to
 * https://confluence.heidelbergcement.com/display/HCP/Running+times+stoppage+types
 * @param equipment
 * @returns
 */
export const getEventStoppageType = (equipment: EquipmentData): StoppageType => {
  if (equipment.equipmentType === EquipmentType.KILN) {
    return 'kiln'
  } else if (equipment.equipmentCategory) {
    return STOPPAGE_TYPE_MAP[equipment.equipmentCategory]
  } else {
    return 'other'
  }
}
